import React from 'react';
import { GridOverlay } from '@mui/x-data-grid-pro';
import SimpleProgressBar from './SimpleProgressBar';

export default function CustomLoadingOverlay() {
  return (
    <GridOverlay>
        <SimpleProgressBar loading={true} size={100}/>
    </GridOverlay>
  );
}
